import type { Context, Lijst } from '@xxtract/tabelfilters';
import { MEDIA_LIBRARY_DISPLAY_TYPES, type MediaLibraryItem } from './media.api';

/**
 * Kolommen van de mediabibliotheek (spec-tabelfilters story 10). De server rekent met dezelfde
 * beschrijving (`MEDIA_LIJST` in `apps/api/src/modules/media/media.service.ts`); sleutels en
 * parameternamen moeten gelijk blijven. Een oude link `?gtin=` wordt het productfilter.
 */
export const MEDIA_LIJST: Lijst<MediaLibraryItem, Context> = {
  kolommen: [
    { sleutel: 'bestand', kopSleutel: 'media.library.list.fileColumn', type: 'tekst', waarde: (r) => r.fileName },
    {
      sleutel: 'type',
      kopSleutel: 'media.library.list.typeColumn',
      type: 'keuzelijst',
      waarde: (r) => r.displayType,
      waardeLabel: (w, t) => t(`media.library.types.${w}`),
      vasteWaarden: MEDIA_LIBRARY_DISPLAY_TYPES,
    },
    {
      sleutel: 'product',
      kopSleutel: 'media.library.list.productColumn',
      type: 'tekst',
      urlNaam: 'gtin',
      waarde: (r) => (r.gtin === '' ? null : r.productName === '' ? r.gtin : `${r.productName} · ${r.gtin}`),
    },
    { sleutel: 'datum', kopSleutel: 'media.library.list.dateColumn', type: 'datum', waarde: (r) => r.uploadDate ?? null },
  ],
  standaardSortering: () => [{ sleutel: 'datum', richting: 'af' }, { sleutel: 'bestand', richting: 'op' }],
  sorteerAliassen: {
    newest: [{ sleutel: 'datum', richting: 'af' }, { sleutel: 'bestand', richting: 'op' }],
    name: [{ sleutel: 'product', richting: 'op' }, { sleutel: 'bestand', richting: 'op' }],
    type: [{ sleutel: 'type', richting: 'op' }, { sleutel: 'product', richting: 'op' }],
  },
};

/**
 * Paginafilters als mini-lijst, zodat een oude link `?query=`, `?brandId=`, `?linked=` en `?view=`
 * door dezelfde lezer gaat. Zoeken zoekt over merk, product, GTIN en bestandsnaam tegelijk en blijft
 * dus een paginafilter; de weergave is geen filter maar wordt hier alleen uit de link gelezen.
 */
export const MEDIA_PAGINAFILTER: Lijst<unknown> = {
  alleenKolomfilters: true,
  kolommen: [
    { sleutel: 'zoek', kopSleutel: 'media.library.filters.searchLabel', type: 'tekst', urlNaam: 'query', waarde: () => null },
    { sleutel: 'merk', kopSleutel: 'media.library.filters.brandLabel', type: 'tekst', urlNaam: 'brandId', waarde: () => null },
    {
      sleutel: 'gekoppeld',
      kopSleutel: 'media.library.filters.unlinkedOnly',
      type: 'keuzelijst',
      urlNaam: 'linked',
      enkelvoudig: true,
      vasteWaarden: ['true', 'false'],
      waarde: () => null,
    },
    {
      sleutel: 'weergave',
      kopSleutel: 'media.library.filters.viewLabel',
      type: 'keuzelijst',
      urlNaam: 'view',
      enkelvoudig: true,
      vasteWaarden: ['grid', 'list'],
      waarde: () => null,
    },
  ],
};

export const mediaSleutel = (gln: string) => `media:${gln}`;
export const mediaPaginaSleutel = (gln: string) => `media.pagina:${gln}`;
